import { render, staticRenderFns } from "./importgood.vue?vue&type=template&id=489c601d&scoped=true&"
import script from "./importgood.vue?vue&type=script&lang=js&"
export * from "./importgood.vue?vue&type=script&lang=js&"
import style0 from "./importgood.vue?vue&type=style&index=0&id=489c601d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c601d",
  null
  
)

export default component.exports